import { resolvePosition, resolveShading, resolveIcon } from "../helpers";

export type Direction = 'up' | 'down' | 'left' | 'right';

interface IProps {
    direction?: Direction;
    onDown?(): void;
    onUp?(): void;
}

export const DirectionButton: React.FC<IProps> = ({direction, onDown, onUp}) => {

    const smallScreenSize = window.innerWidth < 500;

    return ( 
        <button 
            className={`absolute h-13 w-13 bg-black select-none pixel-corners ${resolveShading(direction)} ${resolvePosition(direction)} btn-text shading-active`}
            onMouseDown={smallScreenSize ? undefined: onDown}
            onMouseUp={smallScreenSize ? undefined : onUp}
            onTouchStart={smallScreenSize ? onDown : undefined}
            onTouchEnd={smallScreenSize ? onUp : undefined}
        >
            {resolveIcon(direction)}
        </button>
    )
}